import {
  Component,
  ElementRef, EventEmitter,
  forwardRef,
  HostListener,
  Input,
  OnDestroy,
  OnInit,
  Output, ViewChild,
} from "@angular/core";
import {ControlValueAccessor, FormControl, NG_VALUE_ACCESSOR} from "@angular/forms";
import {FormSelectModelDto, PaymentType} from "../../pages/payment-link-list/models/paylinks.model";
import {debounceTime, filter, map, Subscription} from "rxjs";
import {FilterModelDto} from "../../models/filter.model";

@Component({
  selector: "app-form-custom-search",
  templateUrl: "./form-custom-search.component.html",
  styleUrls: ["./form-custom-search.component.scss"],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FormCustomSearchComponent),
      multi: true,
    },
  ],
})
export class FormCustomSearchComponent implements OnInit, OnDestroy, ControlValueAccessor {
  @Input() title = "";
  @Input() errorText: string = "";
  @Input() currentValue: PaymentType | undefined;
  @Input() itemList: FormSelectModelDto[] = [];
  @Input() searchData: any;

  @Output() searchEvent: EventEmitter<string> = new EventEmitter<string>();

  @ViewChild("searchInput") searchInput!: ElementRef;

  searchFormControl!: FormControl;

  subs: Subscription[] = [];

  isOpen = false;

  onChange = (value: any) => {
  };
  onTouched = (value: any) => {
  };

  constructor(private elRef: ElementRef) {
  }

  ngOnInit() {
    this.searchFormControl = new FormControl(this.currentValue?.payment_type_name ?? '');
    this.initSubscribe();
  }

  ngOnDestroy() {
    this.subs.forEach((item) => item.unsubscribe());
  }

  initSubscribe() {
    this.subs.push(
      this.searchFormControl.valueChanges
        .pipe(
          debounceTime(300)
        )
        .subscribe({
          next: (res) => {
            if (res) {
              this.searchEvent.emit(res);
            }
          },
        })
    );
  }

  @HostListener("document:click", ["$event"])
  clickOut(event: MouseEvent) {
    if (!this.elRef.nativeElement.contains(event.target)) {
      if (this.isOpen) {
        this.searchFormControl.setValue("");
      }
      this.itemList = [];
      this.isOpen = false;
    }
  }

  selectItem(itemSelected: FilterModelDto) {
    const value = this.itemList.find((item) => item.value === itemSelected.value)
    const selectedValue: PaymentType = {
      payment_type_name: value?.description ?? '',
      id: value?.value.toString() ?? ''
    }
    this.onChange(selectedValue)
    this.currentValue = selectedValue
    this.itemList = [];
    this.searchFormControl.setValue('');
    this.isOpen = false;
  }

  writeValue(value: any) {
    this.onChange(this.currentValue);
    this.searchFormControl.setValue('')
  }

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }

  focusFn() {
    this.itemList = [];
    this.isOpen = true;
  }

  onTouchedFn(event: FocusEvent) {
    this.onTouched(event);
  }

  openList() {
    this.isOpen = true
    this.searchInput.nativeElement.focus()
  }
}
